<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.75 20.25V17.5607L17.0732 4.23744C17.1709 4.13981 17.3291 4.13981 17.4268 4.23744L19.7626 6.57322C19.8602 6.67085 19.8602 6.82915 19.7626 6.92678L6.43934 20.25H3.75Z" stroke="currentColor" stroke-width="1.5"/>
  </svg>
</template>
